import dataLayer from '../dataLayer/reducer';
import { KIJS } from '../config';
import grey from '@material-ui/core/colors/grey';

const ITEM_STYLE = {fontSize: '1em', color: grey[300], borderBottom: '1px solid ' + grey[300] };

const DefaultState = {
    active: [],
    activeData: [],
    id: 1,
    data: [
        { id: 5, style: ITEM_STYLE, textStyle: {color: grey[800]}, url: window.location.protocol + "//wms.kartes.lv/" + KIJS + "/wgs/galv_sport_obj/", name: "Galvenie sporta objekti", group: "sporta", active: false},
        { id: 6, style: ITEM_STYLE, textStyle: {color: grey[800]}, url: window.location.protocol + "//wms.kartes.lv/" + KIJS + "/wgs/sport_obj_izv/", name: "Sporta objektu izvietojums", group: "sporta", active: false},
        { id: 7, style: ITEM_STYLE, textStyle: {color: grey[800]}, url: window.location.protocol + "//wms.kartes.lv/" + KIJS + "/wgs/peldb_izv/", name: "Peldbaseinu izvietojums", group: "sporta", active: false},
        { id: 8, style: ITEM_STYLE, textStyle: {color: grey[800]}, url: window.location.protocol + "//wms.kartes.lv/" + KIJS + "/wgs/vieglat_infr/", name: "Vieglatlētikas infrastruktūra", group: "sporta", active: false},
    ]
}

class SIDataLayer extends dataLayer {

    reducerExtender(state, action) {    

        switch(action.type) {
            case 'mobility_ACTIVATE_BY_IDS':
                if(action.data.indexOf("dev_center_atta") > -1) {

                    var newstate = Object.assign({}, state);
                    this.recursiveLoop(newstate.data, (entry)=>{
                        entry.active = false;
                    });
                }

                return newstate;
            break;
            case 'population_TOGGLE_BY_IDS_SINGLE':
                var newstate = Object.assign({}, state);
                this.recursiveLoop(newstate.data, (entry)=>{
                    entry.active = false;
                    
                });
                
                return newstate;
            break;
             case 'schoolMenu_TOGGLE_BY_IDS_SINGLE':

                 
                  if(action.data.indexOf("middle_school_model") > -1) {
                     var newstate = Object.assign({}, state);
                    this.recursiveLoop(newstate.data, (entry)=>{

                      entry.active = false;

                    });
                  }
               return newstate;
               break;

        }

    }

}

var SportInfrastructureData = new SIDataLayer({
  key: "sportInfrastructure",
  defaultState: DefaultState
});

const SportInfrExport = SportInfrastructureData.export();

export const sportInfrastructure = SportInfrExport.sportInfrastructure;
export default SportInfrExport;


// WEBPACK FOOTER //
// ./C:/Users/viesis/Desktop/deportacijas/src/sportInfrastructure/reducer.js